const KIND = { ministry: "Ministry / department", office: "Church office", authorized: "Requires church authorization" };

export const TeamBadges = ({ t }) => {
  const tags = [KIND[t.kind], t.hidden && "Hidden", ...(t.requirements || []).map((r) => `Needs ${r}`)].filter(Boolean);
  if (!tags.length) return null;
  return (
    <div className="flex flex-wrap gap-1.5 mt-2" data-testid={`team-badges-${t.team_id}`}>
      {tags.map((x) => <span key={x} className="text-[11px] bg-paper text-muted-ink rounded-full px-2.5 py-0.5">{x}</span>)}
    </div>
  );
};
